import { render, staticRenderFns } from "./AddReviewerDialog.vue?vue&type=template&id=c2ffd8be&scoped=true&"
import script from "./AddReviewerDialog.vue?vue&type=script&lang=js&"
export * from "./AddReviewerDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddReviewerDialog.vue?vue&type=style&index=0&id=c2ffd8be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ffd8be",
  null
  
)

export default component.exports